import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from './Redux/store'
import { Provider, useSelector } from "react-redux";
import '../src/API/tokens'
// const root = ReactDOM.createRoot(document.getElementById("root"));
import { message } from 'antd';

// Import offline support
import { initializeOfflineSupport } from './offline';
import dataPreloader from './offline/dataPreloader';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = createRoot(document.getElementById("root"))

// Set global message configuration
message.config({
  top: null,
  bottom: 20,
  duration: 1,

});

// Initialize offline support
console.log('🚀 Initializing offline support...');
initializeOfflineSupport();

const shouldRunPreload = () => {
  const state = store.getState();
  const needsSetup = state?.mainDashBoardSlice?.needsSetup;
  const branchId = state?.loginResponseSlice?.value?.branchPk;
  const hasValidBranch = branchId && branchId !== 'noBranch';
  return !needsSetup && hasValidBranch;
};

// Preload critical data for offline access (when online and setup complete)
if (navigator.onLine) {
  setTimeout(() => {
    if (!shouldRunPreload()) {
      console.log('⏭️ Skipping data preload until branch setup completes');
      return;
    }
    console.log('📥 Preloading data for offline access...');
    dataPreloader.preloadAllData();
  }, 3000); // Wait 3 seconds after app load to avoid blocking initial render
}

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

// Register service worker for offline support
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ Service Worker registered - App ready for offline use');
  },
  onUpdate: (registration) => {
    console.log('🔄 New version available');
    message.info('New version available! Please refresh the page.', 3);
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
